import { createRouter, createWebHashHistory } from "vue-router";
import axios from "axios";
import Swal from "sweetalert2";
import store from "@/store";
import {
    swapGetControllerForNavigation,
    abortNavigationGetController,
} from "@/apiService";
// import version from '@/version.json'
// import HomeView from '../views/HomeView.vue'

const routes = [
    {
        path: "/Dashboard",
        name: "Dashboard",
        // component: () => import(/* webpackChunkName: "about" */ '../views/home-dashboard.vue')
        // component: () => import(/* webpackChunkName: "about" */ '../views/Project/ProjectList.vue')
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/projectDashboard.vue"
            ),
    },
    {
        path: "/TestDashboard2",
        name: "TestDashboard2",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/home-dashboard.vue"
            ),
    },
    {
        path: "/quick-access",
        name: "Quick Access",
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/quick-access.vue"),
    },
    {
        path: "/ask-ai",
        name: "Ask AI",
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/ask-ai.vue"),
    },
    {
        path: "/admin-panel/modules",
        name: "Admin Panel - Modules",
        meta: { skipModuleCheck: true },
        component: () =>
            import(
                /* webpackChunkName: "public" */ "../views/admin-panel/modules/Index.vue"
            ),
    },
    {
        path: "/admin-panel/user-access",
        name: "Admin Panel - User Access",
        meta: { skipModuleCheck: true },
        component: () =>
            import(
                /* webpackChunkName: "public" */ "../views/admin-panel/user-access/Index.vue"
            ),
    },
    {
        path: "/admin-panel/special-permissions",
        name: "Admin Panel - Special Permissions",
        meta: { skipModuleCheck: true },
        component: () =>
            import(
                /* webpackChunkName: "public" */ "../views/admin-panel/special-permissions/Index.vue"
            ),
    },
    {
        path: "/",
        alias: "/general-dashboard",
        name: "Home",
        // component: () => import(/* webpackChunkName: "about" */ '../views/home-dashboard.vue')
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/general-dashboard.vue"
            ),
    },
    {
        path: "/DashboardStats",
        name: "Dashboard Stats",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/DashboardStats.vue"
            ),
    },
    {
        path: "/fail-logs",
        name: "Fail Logs",
        component: () =>
            import(/* webpackChunkName: "fail-logs" */ "../views/FailLogs.vue"),
        meta: {
            pageDetails: {
                title: "API Fail Logs",
            },
        },
    },
    {
        path: "/component-records",
        name: "Component Records",
        component: () =>
            import(
                /* webpackChunkName: "component-records" */ "../views/ComponentRecords.vue"
            ),
        meta: {
            pageDetails: {
                title: "Component Records",
            },
        },
    },
    {
        path: "/backcharge-invoices",
        name: "Backcharge Invoices",
        component: () =>
            import(
                /* webpackChunkName: "backcharge-invoices" */ "../views/backcharge-invoices/Index.vue"
            ),
        meta: {
            pageDetails: {
                title: "Backcharge Invoices",
            },
        },
    },
    {
        path: "/material-usages",
        name: "All Material Usages",
        component: () =>
            import(
                /* webpackChunkName: "material-usages" */ "../views/material-usages/Index.vue"
            ),
        meta: {
            pageDetails: {
                title: "Material Usages",
            },
        },
    },
    {
        path: "/import-center",
        name: "Import Center",
        component: () =>
            import(
                /* webpackChunkName: "import-center" */ "../views/ImportCenter.vue"
            ),
        meta: {
            pageDetails: {
                title: "Import Center",
            },
        },
    },
    {
        path: "/component-modified-request",
        name: "Component Modified Request",
        component: () =>
            import(
                /* webpackChunkName: "import-center" */ "../views/ComponentModifiedRequest.vue"
            ),
        meta: {
            pageDetails: {
                title: "Component Modified Request",
            },
        },
    },
    {
        path: "/notifications",
        name: "Notifications",
        component: () =>
            import(
                /* webpackChunkName: "notifications" */ "../views/Notifications.vue"
            ),
        meta: {
            skipModuleCheck: true,
            pageDetails: {
                title: "Notifications",
            },
        },
    },
    {
        path: "/UserProfile",
        name: "User Profile",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/user/UserProfileView.vue"
            ),
    },
    {
        path: "/HR/CreateUser",
        name: "Create User",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/user/UserProfileCreate.vue"
            ),
    },
    {
        path: "/AC/UserAccess",
        name: "User Access",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/AccessControl/UserAccessControlView.vue"
            ),
    },
    {
        path: "/AC/UserAccess/manage/:user_id/:name",
        name: "User Access Control",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/AccessControl/UserAccessControlManage.vue"
            ),
    },
    {
        path: "/AC/UserAccess/control-level",
        name: "Access Level Control",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "@/views/AccessControl/AccessControlView.vue"
            ),
    },
    {
        path: "/AC/UserAccess/control-level/edit/:id",
        name: "Manage User Level",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "@/views/AccessControl/AccessControlEdit.vue"
            ),
    },
    {
        path: "/AC/UserAccess/control-level/create",
        name: "Create User Level",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "@/views/AccessControl/AccessControlCreate.vue"
            ),
    },
    {
        path: "/Login",
        name: "Login",
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/UserLogin.vue"),
    },
    {
        path: "/ViewCompanyProfile",
        name: "ViewCompanyProfile",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/company/ViewCompanyProfile.vue"
            ),
    },
    {
        path: "/CompanyProfileAction",
        name: "CompanyProfileAction",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/company/CompanyProfileAction.vue"
            ),
    },
    {
        path: "/Projects",
        name: "Projects",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Project/ProjectList.vue"
            ),
        meta: {
            pageDetails: {
                title: "Projects",
            },
        },
    },
    {
        path: "/Project Overall",
        name: "ProjectListView",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Project/ProjectListViewOnly.vue"
            ),
        meta: {
            pageDetails: {
                title: "Projects",
            },
        },
    },
    {
        path: "/Projects/Archive",
        name: "Archive Project",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Project/ArchiveProjectList.vue"
            ),
        meta: {
            pageDetails: {
                title: "Archive Projects",
            },
        },
    },
    {
        path: "/Contract/Dashboard",
        name: "Contract Dashboard",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/Dashboard/Index.vue"
            ),
    },
    {
        path: "/contract/revenue-dashboard",
        name: "Revenue Dashboard",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/revenue-dashboard/Index.vue"
            ),
    },
    {
        path: "/contract/component-cost-forecast-dashboard",
        name: "Component Cost Forecast Dashboard",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/component-cost-forecast-dashboard/Index.vue"
            ),
    },
    {
        path: "/contract/progress-claim-dashboard",
        name: "Progress Claim Dashboard",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/progress-claim-dashboard/Index.vue"
            ),
    },
    {
        path: "/contract/details-scopes",
        name: "Contract Details & Scope",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/details-and-scope/Index.vue"
            ),
    },
    {
        path: "/contract/locations/:sub_tab*",
        name: "Location Setup",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/location-setup/Index.vue"
            ),
    },
    {
        path: "/contract/component-grouping/:id?",
        name: "Components Grouping",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/component-grouping/Index.vue"
            ),
    },
    {
        path: "/contract/components-layout",
        name: "Components Layout",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/components-layout/Index.vue"
            ),
    },
    {
        path: "/contract/components-summary",
        name: "Components Summary",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/components-summary/Index.vue"
            ),
    },
    {
        path: "/Contract/Create",
        name: "Create Building Project",
        meta: { skipModuleCheck: true },
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/Create.vue"
            ),
    },
    {
        path: "/contract/details-scopes/:contract_id",
        name: "Scope of Works",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/Scope/Index.vue"
            ),
    },
    {
        path: "/Contract/revenue-forecast/:id?",
        name: "Revenue Forecast",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/revenue-forecast/Index.vue"
            ),
    },
    {
        path: "/contract/revenue-dashboard",
        name: "Revenue Dashboard",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/revenue-dashboard/Index.vue"
            ),
    },
    {
        path: "/Contract/revenue-forecast/casted/:weightage/:date/:start_date/:end_date",
        name: "Forecast Casted Valuation",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/revenue-forecast/show/casted/show.vue"
            ),
    },
    {
        path: "/Contract/revenue-forecast/delivered/:weightage/:date/:start_date/:end_date",
        name: "Forecast Delivered Valuation",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/revenue-forecast/show/delivered/show.vue"
            ),
    },
    {
        path: "/Contract/revenue-forecast/installed/:weightage/:date/:start_date/:end_date",
        name: "Forecast Installed Valuation",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/revenue-forecast/show/installed/show.vue"
            ),
    },
    {
        path: "/Contract/progress-claims",
        name: "Progress Claims",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/progress-claims/Index.vue"
            ),
    },
    {
        path: "/Contract/progress-claim-summary",
        name: "Progress Claim Summary",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/progress-claim-summary/Index.vue"
            ),
    },
    {
        path: "/Contract/progress-claims/create",
        name: "Create Progress Claims",
        meta: { skipModuleCheck: true },
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/progress-claims/Create.vue"
            ),
    },
    {
        path: "/Contract/progress-claims/payment",
        name: "Progress Claims Payment (Building)",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/progress-claims/Payment.vue"
            ),
    },
    {
        path: "/Contract/progress-claims/:id/create-certification",
        name: "Create Progress Certification",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/progress-claims/CreateCertification.vue"
            ),
    },
    {
        path: "/Contract/progress-claims/:id/create-payment",
        name: "Create Progress Payment",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/progress-claims/CreatePayment.vue"
            ),
    },
    {
        path: "/contract/progress-claim-payment-records",
        name: "Progress Claim Payment Records",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/progress-claim-payment-record/Index.vue"
            ),
    },
    {
        path: "/Contract/DeliveredComponentsValuation",
        name: "Delivered Components Valuation",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/DeliveredComponentsValuation/Index.vue"
            ),
    },
    {
        path: "/Contract/CastedComponentsValuation",
        name: "Casted Components Valuation",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/CastedComponentsValuation/Index.vue"
            ),
    },
    {
        path: "/Contract/InstalledComponentsValuation",
        name: "Installed Components Valuation",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/InstalledComponentsValuation/Index.vue"
            ),
    },
    {
        path: "/Contract/DoSummary",
        name: "Do Summary",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/DoSummary/Index.vue"
            ),
    },
    {
        path: "/Contract/ClaimHistory",
        name: "Claim History",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/ClaimHistory/Index.vue"
            ),
    },
    {
        path: "/Contract/ClaimDetails/:id",
        name: "Claim Details",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/ClaimHistory/Show.vue"
            ),
    },
    {
        path: "/Contract/AttachmentSummary",
        name: "Attachment Summary",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/Attachment/Index.vue"
            ),
    },
    {
        path: "/Contract/Attach_1/:id",
        name: "Attachment 1 - Do Summary",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/Attachment/Att_1_DoSummary/Index.vue"
            ),
    },
    {
        path: "/Contract/Attach_2/:id",
        name: "Attachment 2 - Component Grouping Summary",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/Attachment/Att_2_ComponentGroupingSummary/Index.vue"
            ),
    },
    {
        path: "/Contract/Attach_3/:id",
        name: "Attachment 3 - Post Pour Summary",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/Attachment/Att_3_PostPourSummary/Index.vue"
            ),
    },
    {
        path: "/Contract/Attach_4/:id",
        name: "Attachment 4 - Component Grouping Summary",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/Attachment/Att_4_ComponentGroupingSummary/Index.vue"
            ),
    },
    {
        path: "/Contract/Attach_5/:id",
        name: "Attachment 5 - Post Pour Summary",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/Attachment/Att_5_PostPourSummary/Index.vue"
            ),
    },
    {
        path: "/Contract/Attach_6/:id",
        name: "Attachment 6 - Component Grouping Summary",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/Attachment/Att_6_ComponentGroupingSummary/Index.vue"
            ),
    },
    {
        path: "/Contract/discard-management-recovery/:id?",
        name: "Discard Management Recovery",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/discard-component-pending-list/Index.vue"
            ),
    },
    {
        path: "/Project/ProjectSettings/:id?/:tab?/:sub_tab*",
        name: "Project Settings",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/Manage/ProjectSettings.vue"
            ),
    },
    {
        path: "/Project/delivery-request-receiving-record",
        name: "Delivery Request Receiving Record",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Project/delivery-request-receiving-record/Index.vue"
            ),
    },
    {
        path: "/project/delivery-variances",
        name: "Delivery Variances",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Project/delivery-variances/Index.vue"
            ),
    },
    {
        path: "/Project/delivery-summary-report",
        name: "Delivery Summary Report",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Project/delivery-summary-report/Index.vue"
            ),
    },
    {
        path: "/Project/progress-summary-report",
        name: "Progress Summary Report",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Project/progress-summary-report/Index.vue"
            ),
    },
    {
        path: "/Project/progress-wall-chart/:id?",
        name: "Progress Wall Chart",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Project/progress-wall-chart/Index.vue"
            ),
    },
    {
        path: "/Project/VOItems/:contract_id?",
        name: "Manage VO Items",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Contract/Manage/VOItems.vue"
            ),
    },
    {
        path: "/Project/delivery-instruction/:instruction_id?",
        name: "Delivery Instruction",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Project/delivery-instruction/Index.vue"
            ),
    },
    {
        path: "/Project/Instruction/Create",
        name: "Create Delivery Instruction",
        meta: { skipModuleCheck: true },
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Project/delivery-instruction/Create.vue"
            ),
    },
    {
        path: "/Delivery/product-export-pricing",
        name: "Delivery Product Export Pricing",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Delivery/product-export-pricing/Index.vue"
            ),
    },
    {
        path: "/bridge/financial-analysis",
        name: "Bridge Financial Analysis",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/bridge/financial-analysis/Index.vue"
            ),
    },
    {
        path: "/bridge/delivery/delivery-vo",
        name: "Delivery VO",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/bridge/delivery-vo/Index.vue"
            ),
    },
    {
        path: "/Delivery/Order/:id?",
        name: "Delivery Order",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Delivery/Order/Index.vue"
            ),
    },
    {
        path: "/Delivery/do-status-updates",
        name: "Delivery Order Status Update",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Delivery/do-status-update/Index.vue"
            ),
    },
    {
        path: "/Delivery/do-status-update/create",
        name: "Create Delivery Order",

        meta: { skipModuleCheck: true },
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Delivery/do-status-update/Create.vue"
            ),
    },
    {
        path: "/Delivery/ComponentReturnRequest/:id?",
        name: "Component Return Request",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Delivery/ComponentReturnRequest/Index.vue"
            ),
    },
    {
        path: "/Delivery/component-discard-requests/:id?",
        name: "Discard Component List",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Delivery/component-discard-requests/Index.vue"
            ),
    },
    {
        path: "/Delivery/loading-plan/:id?",
        name: "Loading Plan",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Delivery/loading-plan/Index.vue"
            ),
    },
    {
        path: "/Delivery/loading-plan/create",
        name: "Create Loading Plan",

        meta: { skipModuleCheck: true },
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Delivery/loading-plan/Create.vue"
            ),
    },
    {
        path: "/Delivery/loading-plan/view/:id",
        name: "View Loading Plan",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Delivery/loading-plan/Show.vue"
            ),
    },
    {
        path: "/Delivery/loading-plan/Manage/:project_id/:instruction_id",
        name: "Manage Loading Plan",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Delivery/loading-plan/Manage.vue"
            ),
    },
    {
        path: "/Delivery/pre-delivery-inspections",
        name: "Pre Delivery Inspections",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Delivery/pre-delivery-inspections/Index.vue"
            ),
    },
    {
        path: "/Delivery/pre-delivery-inspections/view/:id",
        name: "View Pre Delivery Inspections",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Delivery/pre-delivery-inspections/Show.vue"
            ),
    },
    {
        path: "/Delivery/pre-delivery-inspections/create/:id_list",
        name: "Create Pre Delivery Inspections",

        meta: { skipModuleCheck: true },
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Delivery/pre-delivery-inspections/Create.vue"
            ),
    },
    {
        path: "/Customer",
        name: "Customers",
        meta: { skipModuleCheck: true },
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/customer/Index.vue"
            ),
    },
    {
        path: "/Customer/:customer_id",
        name: "Manage Customer",
        meta: { skipModuleCheck: true },
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/customer/Manage.vue"
            ),
    },
    {
        path: "/Worker-SubCon",
        name: "Worker & Subcontractor",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/WorkerSubCon/WorkerSubConView.vue"
            ),
    },
    {
        path: "/HR/Position",
        name: "Position",
        meta: { skipModuleCheck: true },
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/HRM/Position/Index.vue"
            ),
    },
    {
        path: "/HR/Employee",
        name: "Employees",
        meta: { skipModuleCheck: true },
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/HRM/Employee/Index.vue"
            ),
    },
    {
        path: "/HR/Employee/:id",
        name: "Employee Details",
        meta: { skipModuleCheck: true },
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/HRM/Employee/Show.vue"
            ),
    },
    {
        path: "/HR/Department",
        name: "Departments",
        meta: { skipModuleCheck: true },
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Department/DepartmentView.vue"
            ),
    },
    {
        path: "/HR/Department/:department_id",
        name: "Department Information",
        meta: { skipModuleCheck: true },
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Department/DepartmentDetailView.vue"
            ),
    },
    {
        path: "/Project/Create",
        name: "Create Bridge Project",

        meta: { skipModuleCheck: true },
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Project/CreateProject.vue"
            ),
    },
    {
        path: "/Project/Edit/:project_id",
        name: "Edit Project",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Project/ProjectEdit.vue"
            ),
    },
    {
        path: "/Project/View/:project_id/:tab?",
        name: "Project Information",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Project/ViewProjectInfo.vue"
            ),
    },
    {
        path: "/Project/MobileVerticalMarking/:project_id",
        name: "Mobile Vertical Marking",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Project/MobileVerticalMarking.vue"
            ),
    },
    {
        path: "/Project/View/Drawings/:project_id",
        name: "Drawings",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Project/ViewDrawingsByProject.vue"
            ),
    },
    {
        path: "/Projects/DeliveryOrders",
        name: "Delivery Orders",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Project/DeliveryOrdersView.vue"
            ),
    },
    {
        path: "/Projects/NCR",
        name: "NCR",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Project/NcrView.vue"
            ),
    },
    {
        path: "/Project/BatchUpdate/:project_id/:project_name/:type/:id_list",
        name: "Batch Update",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Project/BatchUpdate.vue"
            ),
    },
    {
        path: "/Project/ViewProjectBound/:project_id/:site_component_id",
        name: "View Marking",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Project/ViewProjectBound.vue"
            ),
    },
    {
        path: "/Project/ViewProjectBoundBySection/:project_id/:section_id/:project_name",
        name: "View Project Bound By Section",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Project/ProjectStatusBySection.vue"
            ),
    },
    {
        path: "/CreateSection/:project_id/",
        name: "Create Section",
        meta: { skipModuleCheck: true },
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Section/CreateSection.vue"
            ),
    },
    {
        path: "/Project/ViewProjectBoundByCategory/:project_id/:category_id/:project_name",
        name: "View Project Bound By Category",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Project/ProjectStatusByCategory.vue"
            ),
    },
    {
        path: "/Mould/MouldList/:project_id?",
        name: "Mould List",
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/Mould/Index.vue"),
    },
    {
        path: "/Mould/Management/:project_id?",
        name: "Mould Management",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Mould/Management/Index.vue"
            ),
    },
    {
        path: "/Mould/Management/Building/:project_id?",
        name: "Building for Mould Management",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Mould/Management/Building/Index.vue"
            ),
    },
    {
        path: "/Mould/Deployment/:id?",
        name: "Mould Fabrication And Deployment",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Mould/Deployment/Index.vue"
            ),
    },
    {
        path: "/Mould/List/:id?",
        name: "All Mould List",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Mould/List/Index.vue"
            ),
    },
    {
        path: "/mould-production/service-mode",
        name: "Mould Service Mode",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Mould/mould-service/mode/Index.vue"
            ),
    },
    {
        path: "/mould-production/service-tracking",
        name: "Mould Service Tracking",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Mould/mould-service/tracking/Index.vue"
            ),
    },
    {
        path: "/mould-production/service-summary",
        name: "Mould Service Summary",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Mould/mould-service/summary/Index.vue"
            ),
    },
    {
        path: "/mould-production/parts",
        name: "Mould Parts",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Mould/parts/Index.vue"
            ),
    },
    {
        path: "/mould-production/steel-place-and-steel-profile",
        name: "Steel Plate & Steel Profile",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/mould-production/steel-place-and-steel-profile/Index.vue"
            ),
    },
    {
        path: "/Project/delivery-forecast/:id?",
        name: "Delivery Forecast",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Project/delivery-schedule/Index.vue"
            ),
    },
    // {
    //     path: "/production/dashboard",
    //     name: "Production Dashboard",
    //     component: () =>
    //         import(
    //             /* webpackChunkName: "about" */ "../views/Production/dashboard/Index.vue"
    //         ),
    // },
    {
        path: "/building/dashboard",
        name: "Building Dashboard",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/building/dashboard/Index.vue"
            ),
    },
    {
        path: "/bridge/dashboard",
        name: "Bridge Dashboard",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/bridge/dashboard/Index.vue"
            ),
    },
    {
        path: "/bridge/financial-dashboard",
        name: "Financial Dashboard",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/bridge/financial-dashboard/Index.vue"
            ),
    },
    {
        path: "/building/financial-dashboard",
        name: "Building Financial Dashboard",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/building/financial-dashboard/Index.vue"
            ),
    },
    {
        path: "/project-cost/actual-cost-breakdown",
        name: "Actual Cost Breakdown",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/project-cost/actual-cost-breakdown/Index.vue"
            ),
        // The page handles its own project gate; remove once a module link
        // for this path is configured in backend permissions.
        meta: { skipModuleCheck: true },
    },
    {
        path: "/bridge/components",
        name: "Bridge Components",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/bridge/components/Index.vue"
            ),
    },
    {
        path: "/bridge/progress-claims",
        name: "Progress Claims (Bridge)",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/bridge/progress-claims/Index.vue"
            ),
    },
    {
        path: "/bridge/progress-claims/create",
        name: "Create Progress Claim (Bridge)",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/bridge/progress-claims/Create.vue"
            ),
    },
    {
        path: "/bridge/progress-claims/:id/edit",
        name: "Edit Progress Claim (Bridge)",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/bridge/progress-claims/Edit.vue"
            ),
    },
    {
        path: "/bridge/progress-claims/payment",
        name: "Progress Claims Payment (Bridge)",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/bridge/progress-claims/Payment.vue"
            ),
    },
    {
        path: "/bridge/progress-claims/:id/create-certification",
        name: "Create Progress Certification (Bridge)",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/bridge/progress-claims/CreateCertification.vue"
            ),
    },
    {
        path: "/bridge/progress-claims/:id/create-payment",
        name: "Create Progress Payment (Bridge)",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/bridge/progress-claims/CreatePayment.vue"
            ),
    },
    {
        path: "/wh/rebar-usages",
        name: "Rebar Usages",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Warehouse/rebar-usages/Index.vue"
            ),
    },
    {
        path: "/wh/stock-take",
        name: "Stock Take",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Warehouse/warehouse-openings/Index.vue"
            ),
    },
    {
        path: "/bridge/wh/dashboard",
        name: "Warehouse Dashboard (Bridge)",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/bridge/warehouse/dashboard/Index.vue"
            ),
    },
    {
        path: "/bridge/wh/bom",
        name: "Bill Of Materials (Bridge)",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/bridge/warehouse/bom/Index.vue"
            ),
    },
    {
        path: "/bridge/wh/bom/:id",
        name: "Bill Of Materials (Bridge) Details",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/bridge/warehouse/bom/Show.vue"
            ),
    },
    {
        path: "/bridge/pricing/view",
        name: "Pricing",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/bridge/pricing/mould/Index.vue"
            ),
    },
    {
        path: "/bridge/pricing/labour-cost",
        name: "Labour Cost (Bridge)",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/bridge/pricing/labour-cost/Index.vue"
            ),
    },
    {
        path: "/building/pricing/labour-cost",
        name: "Labour Cost (Building)",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/building/pricing/labour-cost/Index.vue"
            ),
    },
    {
        path: "/building/manpower/salary",
        name: "Manpower Salary (Building)",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/building/manpower/salary.vue"
            ),
    },
    {
        path: "/building/manpower/dashboard",
        name: "Building Manpower Dashboard",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/building/manpower/dashboard.vue"
            ),
    },
    {
        path: "/building/wh/bom-summary",
        name: "BOM Summary",
        component: () =>
            import(
               /* webpackChunkName: "about" */ "../views/building/warehouse/bom-summary/Index.vue"
            ),
    },
    {
        path: "/tunnel/labour-cost-sub",
        name: "Labour Cost (Sub)",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/tunnel/labour-cost-sub/Index.vue"
            ),
    },
    {
        path: "/tunnel/delivery-setting",
        name: "Tunnel Delivery Setting",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/tunnel/delivery-setting/Index.vue"
            ),
    },
    {
        path: "/bridge/pricing/dashboard",
        name: "Pricing Dashboard (Bridge)",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/bridge/pricing/dashboard/Index.vue"
            ),
    },
    {
        path: "/bridge/material-usage",
        name: "Bridge Material Usage",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/bridge/material-usage/Index.vue"
            ),
    },
    {
        path: "/bridge/activities-setup",
        name: "Bridge Activities Setup",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/bridge/activities-setup/Index.vue"
            ),
    },
    {
        path: "/Production/mould-group-planning",
        name: "Mould Grouping Setup",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Production/mould-group-planning/Index.vue"
            ),
    },
    {
        path: "/Production/mould-group-planning/assign-mould/:id/:component_grouping_id",
        name: "Assign Mould",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Production/mould-group-planning/assign-mould.vue"
            ),
    },
    {
        path: "/Production/production-planning/:id?",
        name: "Production Planning",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Production/production-planning/Index.vue"
            ),
    },
    {
        path: "/Production/job-order/:id?",
        name: "Job Order",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Production/job-order/Index.vue"
            ),
    },
    {
        path: "/Production/batch-component-planning",
        name: "Batch Component Planning",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Production/batch-component-planning/Index.vue"
            ),
    },
    {
        path: "/Production/casting-summary",
        name: "Casting Summary",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Production/casting-summary/Index.vue"
            ),
    },
    {
        path: "/Production/approval-casting-instructions",
        name: "Casting Instruction",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Production/approval-casting-instructions/Index.vue"
            ),
    },
    {
        path: "/Production/approval-casting-instructions/:id/:job_order_id",
        name: "Casting Instruction Details",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Production/approval-casting-instructions/Show.vue"
            ),
    },
    {
        path: "/Production/pre-pour-inspection-requests/:id?",
        name: "Pre Pour Inspection",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Production/pre-pour-inspection-requests/Index.vue"
            ),
    },
    {
        path: "/Production/pre-pour-inspection-requests/:project_id/:id",
        name: "Manage Pre Pour Inspection",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Production/pre-pour-inspection-requests/Manage.vue"
            ),
    },
    {
        path: "/Production/pre-pour-inspection-requests/View/:project_id/:id",
        name: "View Pre Pour Inspection",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Production/pre-pour-inspection-requests/Show.vue"
            ),
    },
    {
        path: "/Production/pre-pour-inspection-checklists",
        name: "Pre Pour Inspection Checklists",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Production/pre-pour-inspection-checklists/Index.vue"
            ),
    },
    {
        path: "/Production/pre-pour-inspection-checklists/view/:id?",
        name: "View Pre Pour Inspection Checklist",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Production/pre-pour-inspection-checklists/Display.vue"
            ),
    },
    {
        path: "/Production/ncr",
        name: "NCR Management",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Production/ncr/Index.vue"
            ),
    },
    {
        path: "/Production/post-pour-component-discard-processes",
        name: "Post Pour Component Discard Processes",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Production/post-pour-component-discard-processes/Index.vue"
            ),
    },
    {
        path: "/Production/casting-confirmation",
        name: "Casting Confirmation",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Production/casting-confirmation/Index.vue"
            ),
    },
    {
        path: "/Production/casting-confirmation/:id",
        name: "Casting Confirmation Details",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Production/casting-confirmation/Show.vue"
            ),
    },
    {
        path: "/Production/casting-confirmation/post-pour-inspection/:id",
        name: "Post Pour Inspection",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Production/casting-confirmation/PostPourInspection.vue"
            ),
    },
    {
        path: "/Production/casting-summary-reports",
        name: "Casting Summary Reports",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Production/casting-summary-reports/Index.vue"
            ),
    },
    {
        path: "/production/time-cards",
        name: "Time Cards",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Production/time-cards/Index.vue"
            ),
    },
    {
        path: "/production/concrete-material-wastage",
        name: "Concrete Material Wastage",
        component: () =>
            import(
                /* webpackChunkName: "concrete-material-wastage" */ "../views/Production/concrete-material-wastage/Index.vue"
            ),
        meta: {
            pageDetails: {
                title: "Concrete Material Wastage",
            },
        },
    },
    {
        path: "/production/work-teams",
        name: "Work Teams",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Production/work-teams/Index.vue"
            ),
    },
    {
        path: "/Mould/ProductionPlanning/:id?",
        name: "Bridge/Tunnel Production Planning",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Mould/ProductionPlanning.vue"
            ),
    },
    {
        path: "/Mould/ProductionPlanning/Create",
        name: "Create Mould Task Planning",
        meta: { skipModuleCheck: true },
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Mould/ProductionPlanningCreate.vue"
            ),
    },
    {
        path: "/Mould/AssignMarking",
        name: "Mould Assign Marking",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Mould/MouldAssignMarking.vue"
            ),
    },
    {
        path: "/Drawings",
        name: "Drawings List",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Drawings/DrawingsView.vue"
            ),
    },
    {
        path: "/DrawingsBatchUpdate",
        name: "Drawings Batch Update",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Project/DrawingsBatchUpdate.vue"
            ),
    },
    {
        path: "/DrawingsKPI",
        name: "Drawings KPI",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/KPI/DrawingsKPI.vue"
            ),
    },
    {
        path: "/FileManager/:id?",
        name: "File Manager",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/File/FileManager.vue"
            ),
    },
    {
        path: "/DrawingsKPI/SetTargets",
        name: "Set Targets",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/KPI/DrawingSetDailyTarget.vue"
            ),
    },
    {
        path: "/Achievement",
        name: "Achievement",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/user/AchievementView.vue"
            ),
    },
    {
        path: "/Logs/ViewAll/:id/:project_id",
        name: "Logs",
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/Log/LogView.vue"),
    },
    {
        path: "/WH/Dashboard",
        name: "Warehouse Dashboard",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Warehouse/WarehouseDashboard.vue"
            ),
    },
    {
        path: "/wh/material-incomings",
        name: "Material Incomings",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Warehouse/material-incomings/Index.vue"
            ),
    },
    {
        path: "/wh/material-costing",
        name: "Material Costing",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Warehouse/material-costing/Index.vue"
            ),
    },
    {
        path: "/wh/material-consumptions",
        name: "Material Consumptions",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Warehouse/material-consumptions/Index.vue"
            ),
    },
    {
        path: "/wh/material-consumption-forecast",
        name: "Material Consumption Forecast",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Warehouse/material-consumption-forecast/Index.vue"
            ),
    },
    {
        path: "/wh/general-material-consumptions",
        name: "General Material Consumptions",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Warehouse/general-material-consumptions/Index.vue"
            ),
    },
    {
        path: "/wh/design-mix",
        name: "Design Mix",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Warehouse/design-mix/Index.vue"
            ),
    },
    {
        path: "/wh/material-supply-setup",
        name: "Material Supply Setup",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Warehouse/material-supply-setup/Index.vue"
            ),
    },
    {
        path: "/wh/material-takeoff",
        name: "Material Takeoff",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Warehouse/material-takeoff/Index.vue"
            ),
    },
    {
        path: "/WH/Materials",
        name: "Materials",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Warehouse/Material/Index.vue"
            ),
    },
    {
        path: "/WH/Material/Create",
        name: "Create Material",
        meta: { skipModuleCheck: true },
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Materials/MaterialCreate.vue"
            ),
    },
    {
        path: "/WH/Material/:id",
        name: "Edit Material",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Warehouse/Material/Show.vue"
            ),
    },
    {
        path: "/WH/MaterialBom/:id",
        name: "Material Bom",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Materials/MaterialBom.vue"
            ),
    },
    {
        path: "/WH/MaterialOrder",
        name: "Material Order",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Warehouse/MaterialOrder/Index.vue"
            ),
    },
    {
        path: "/WH/MaterialOrder/Create/:marking_list?/:project_id?",
        name: "Create Material Order",
        meta: { skipModuleCheck: true },
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Warehouse/MaterialOrder/Manage.vue"
            ),
    },
    {
        path: "/WH/MaterialOrder/Edit/:order_id",
        name: "Manage Material Order",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Warehouse/MaterialOrder/Manage.vue"
            ),
    },
    {
        path: "/WH/MaterialOrder/View/:order_id",
        name: "View Material Order",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Warehouse/MaterialOrder/Manage.vue"
            ),
    },
    {
        path: "/WH/MaterialOrder/Summary/category/:value/:startDate/:endDate",
        name: "Material Order Summary",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Warehouse/MaterialOrder/Summary.vue"
            ),
    },
    {
        path: "/WH/MaterialOrder/Summary/marking/:value/:startDate/:endDate",
        name: "Material Order Summary By Marking",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Warehouse/MaterialOrder/MarkingSummary.vue"
            ),
    },
    {
        path: "/WH/batching-plant",
        name: "Batching Plant",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Warehouse/batching-plant/Index.vue"
            ),
    },
    {
        path: "/WH/material-usages",
        name: "Material Usages",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Warehouse/material-usages/Index.vue"
            ),
    },
    {
        path: "/WH/material-usages/manage",
        name: "Material Usage Delete Requests",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Warehouse/material-usages/Manage.vue"
            ),
        meta: {
            skipModuleCheck: true,
            pageDetails: {
                title: "Material Usage Delete Requests",
            },
        },
    },
    {
        path: "/WH/rebar-summary",
        name: "Rebar Summary",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Warehouse/rebar-summary/Index.vue"
            ),
    },
    {
        path: "/WH/Warehouse",
        name: "Warehouse",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Warehouse/Stock/Index.vue"
            ),
    },
    {
        path: "/WH/Bom",
        name: "Bill Of Materials",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Warehouse/material-bom/Index.vue"
            ),
    },
    {
        path: `/WH/Bom/:id`,
        name: "Edit Bom",
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/Bom/Manage.vue"),
    },
    {
        path: "/WH/Suppliers/:id?",
        name: "Suppliers",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Warehouse/Suppliers/Index.vue"
            ),
    },
    {
        path: "/WH/PrimeMover/:id?",
        name: "Prime Mover",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Warehouse/PrimeMover/Index.vue"
            ),
    },
    {
        path: "/mould-production/dashboard",
        name: "Mould Dashboard",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/mould-production/dashboard/Index.vue"
            ),
    },
    {
        path: "/mould-production/mould-fabrication-planning",
        name: "Mould Fabrication Planning",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/mould-production/mould-fabrication-planning/Index.vue"
            ),
    },
    {
        path: "/mould-production/mould-capacity-forecast",
        name: "Mould Capacity Forecast",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/mould-production/mould-capacity-forecast/Index.vue"
            ),
    },
    {
        path: "/mould-production/mould-bom-costing",
        name: "Mould BOM Costing",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/mould-production/mould-bom-costing/Index.vue"
            ),
    },
    {
        path: "/mould-production/mould-takeoff",
        name: "Mould Takeoff",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/mould-production/mould-takeoff/Index.vue"
            ),
    },
    {
        path: "/mould-production/mould-material-receiving-do/:id?",
        name: "Mould Material Receiving DO",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/mould-production/mould-material-receiving-do/Index.vue"
            ),
    },
    {
        path: "/Settings/ExchangeRate",
        name: "Exchange Rate",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Settings/ExchangeRate.vue"
            ),
    },
    {
        path: "/empty",
        name: "Empty",
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/EmptyPage.vue"),
    },
    {
        path: "/sankey",
        name: "Sankey",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/SankeyDiagramChartExample.vue"
            ),
    },
    {
        path: "/sankey2",
        name: "Sankey2",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Playground/ChartJsSankey.vue"
            ),
    },
    {
        path: "/redirect",
        name: "Redirect Page",
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/RedirectPage.vue"),
    },
    {
        path: "/MasterSettings/Wagon",
        name: "Wagon",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/MasterSettings/Wagon/Index.vue"
            ),
    },
    {
        path: "/master-settings/Checklist",
        name: "Checklist",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/master-settings/Checklist/Index.vue"
            ),
    },
    {
        path: "/MasterSettings/Unit",
        name: "Unit",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/MasterSettings/Unit/Index.vue"
            ),
    },
    {
        path: "/transportation-prices",
        name: "Transportation Prices",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/transportation-prices/Index.vue"
            ),
    },
    {
        path: "/bridge/delivery/theoretical-transportations",
        name: "Theoretical Transportations",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/bridge/delivery/theoretical-transportations/Index.vue"
            ),
    },
    {
        path: "/bridge/delivery/actual-transportations",
        name: "Actual Transportations",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/bridge/delivery/actual-transportations/Index.vue"
            ),
    },
    {
        path: "/bridge/volume-rate/dashboard",
        name: "Volume Rate Dashboard",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/bridge/volume-rate/Index.vue"
            ),
    },
    {
        path: "/bridge/volume-rate/setting",
        name: "Volume Rate Setting",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/bridge/volume-rate/RateSetting.vue"
            ),
    },
    {
        path: "/master-settings/production-line",
        name: "Production Line",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/master-settings/production-line/Index.vue"
            ),
    },
    {
        path: "/master-settings/density",
        name: "Density",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/master-settings/density/Index.vue"
            ),
    },
    {
        path: "/master-settings/mesh-brc-kg-per-m2",
        name: "MeshBrcKgPerM2Settings",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/master-settings/mesh-brc-kg-per-m2/Index.vue"
            ),
    },
    {
        path: "/master-settings/payment-terms",
        name: "Payment Terms",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/master-settings/payment-terms/Index.vue"
            ),
    },
    {
        path: "/master-settings/retention",
        name: "Retention",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/master-settings/retention/Index.vue"
            ),
    },
    {
        path: "/master-settings/public-holiday",
        name: "Public Holiday",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/master-settings/public-holiday/Index.vue"
            ),
    },
    {
        path: "/master-settings/working-sunday",
        name: "Working Sunday",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/master-settings/working-sunday/Index.vue"
            ),
    },
    {
        path: "/master-settings/progress-claim-weightage",
        name: "Progress Claim Weightage",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/master-settings/progress-claim-weightage/Index.vue"
            ),
    },
    {
        path: "/Project/create-tunnel-project",
        name: "Create Tunnel Project",
        meta: { skipModuleCheck: true },
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/Project/create-tunnel-project/Index.vue"
            ),
    },
    {
        path: "/tunnel-segment-delivery",
        name: "Tunnel Segment Delivery",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/tunnel/delivery/Index.vue"
            ),
    },
    {
        path: "/tunnel/manpower-dashboard",
        name: "Tunnel Manpower Dashboard",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/tunnel/manpower-dashboard/Index.vue"
            ),
    },
    {
        path: "/tunnel/financial-analysis",
        name: "Tunnel Financial Analysis",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/tunnel/financial-analysis/Index.vue"
            ),
    },
    {
        path: "/tunnel-segment/progress-claims",
        name: "Progress Claims (Tunnel)",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/tunnel/progress-claims/Index.vue"
            ),
    },
    {
        path: "/tunnel-segment/costing-formula",
        name: "Tunnel Segment Costing Formula",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/tunnel/costing-formula/Index.vue"
            ),
    },
    {
        path: "/tunnel-segment/progress-claim/create",
        name: "Create Progress Claim (Tunnel Segment)",
        meta: { skipModuleCheck: true },
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/tunnel/progress-claims/Create.vue"
            ),
    },
    {
        path: "/tunnel-segment/progress-claims/:id/edit",
        name: "Edit Progress Claim (Tunnel)",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/tunnel/progress-claims/Edit.vue"
            ),
    },
    {
        path: "/tunnel-segment/progress-claims/:id/create-certification",
        name: "Create Progress Certification (Tunnel)",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/tunnel/progress-claims/CreateCertification.vue"
            ),
    },
    {
        path: "/tunnel-segment/progress-claims/payment",
        name: "Progress Claims Payment (Tunnel)",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/tunnel/progress-claims/Payment.vue"
            ),
    },
    {
        path: "/tunnel-segment/progress-claims/:id/create-payment",
        name: "Create Progress Payment (Tunnel)",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/tunnel/progress-claims/CreatePayment.vue"
            ),
    },
    {
        path: "/tunnel/settings/type_activities_setup",
        name: "Type Activities Setup",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/tunnel/settings/type-activities-setup/Index.vue"
            ),
    },
    {
        path: "/TunnelSegmentSummary",
        name: "Tunnel Segment Summary",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/TunnelSegmentSummary/Index.vue"
            ),
    },
    {
        path: "/tunnel-segment/dashboard",
        name: "Tunnel Financial Dashboard",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/tunnel-dashboard/Index.vue"
            ),
    },
    {
        path: "/production-dashboard",
        name: "Production Dashboard",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/production-dashboard/Index.vue"
            ),
    },
    {
        path: "/tunnel-segment/dashboard/detail",
        name: "Detail Summary",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/tunnel-dashboard/detail/Index.vue"
            ),
    },
    {
        path: "/TunnelSegmentSummary/:id",
        name: "Tunnel Segment Summary View",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/TunnelSegmentSummary/Show.vue"
            ),
    },
    {
        path: "/production-schedule",
        name: "Contract Production Schedule",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/production-forecast/Index.vue"
            ),
    },
    {
        path: "/staffs",
        name: "Staffs",
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/staffs/Index.vue"),
    },
    {
        path: "/staffs/supervisor/:id",
        name: "Supervisor",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/staffs/supervisor/Index.vue"
            ),
    },
    {
        path: "/staffs/staff/:id",
        name: "Staff",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/staffs/staff/Index.vue"
            ),
    },
    {
        path: "/staffs/worker/:id",
        name: "Worker",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/staffs/worker/Index.vue"
            ),
    },
    {
        path: "/manpower",
        name: "Manpower",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/manpower/Index.vue"
            ),
    },
    {
        path: "/manpower/records",
        name: "Manpower Records",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/manpower/records/Index.vue"
            ),
    },
    {
        path: "/vehicles",
        name: "Vehicles",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/crm/vehicles/Index.vue"
            ),
    },
    {
        path: "/dashboard-playground",
        name: "Dashboard Playground",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/dashboard-playground.vue"
            ),
    },
    {
        path: "/insert-manpower",
        name: "Insert Manpower",
        meta: { skipModuleCheck: true },
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/manpower/Create.vue"
            ),
    },
    {
        path: "/project-settings",
        name: "Project Settings",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/project-settings/Index.vue"
            ),
    },
    {
        path: "/view-component-status/:id",
        name: "View Component Status",
        component: () =>
            import(
                /* webpackChunkName: "public" */ "../views/public/ViewComponentStatus.vue"
            ),
        meta: {
            public: true,
            skipModuleCheck: true,
        },
    },
    {
        path: "/universal-dashboard",
        name: "Universal Dashboard",
        component: () =>
            import(
                /* webpackChunkName: "public" */ "../views/public/UniversalDashboard.vue"
            ),
        meta: {
            public: true,
            skipModuleCheck: true,
        },
    },
    {
        path: "/404",
        name: "404",
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/404page.vue"),
    },
    // Catch all route - must be last
    {
        path: "/:pathMatch(.*)*",
        name: "NotFound",
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/404page.vue"),
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

async function checkAppNewVersion() {
    const url = `version.json?t=${Date.now()}`;
    let res = null;
    try {
        res = await axios.get(url);
    } catch (err) {
        console.error("checkAppNewVersion error: ", err);
    }

    if (!res) return;
    const version = res.data.version;
    const localVersion = localStorage.getItem("version");

    if (!localVersion) {
        localStorage.setItem("version", version);
    } else {
        if (version != localVersion) {
            localStorage.setItem("version", version);
            Swal.fire(
                "New Version Available",
                "Please refresh the page to update the application",
                "warning",
            ).then(() => {
                location.reload(true);
            });
        }
    }
}
// Route names that are always accessible without module permission checks
const UNRESTRICTED_ROUTE_NAMES = new Set([
    "Login",
    "Home",
    "Ask AI",
    "Fail Logs",
    "User Profile",
    "Create User",
    "ViewCompanyProfile",
    "CompanyProfileAction",
    "404",
    "NotFound",
    "Redirect Page",
    "Empty",
]);

/**
 * Returns the link of the first submodule the user has access to,
 * sorted by module order then submodule order.
 * Falls back to "/" if nothing is found.
 */
function getFirstAllowedPath(userModules) {
    // console.log(
    //     "Determining first allowed path from user modules:",
    //     userModules,
    // );
    console.log("getFirstAllowedPath");
    console.log(userModules);

    if (!userModules || userModules.length === 0) return "/";

    const dashboardList = [
        "/building/financial-dashboard",
        "/bridge/financial-dashboard",
        "/tunnel-segment/dashboard",
    ];

    if (userModules.some((m) => dashboardList.includes(m.link))) {
        return (
            dashboardList.find((dash) =>
                userModules.some((m) => m.link === dash),
            ) || "/"
        );
    }

    const sorted = [...userModules].sort(
        (a, b) => (a.order ?? 0) - (b.order ?? 0),
    );
    for (const mod of sorted) {
        const subs = [...(mod.submodule || [])].sort(
            (a, b) => (a.order ?? 0) - (b.order ?? 0),
        );
        for (const sub of subs) {
            if (sub.link && sub.link !== "-") return sub.link;
        }
    }
    return "/";
}

/**
 * Check whether the target route is permitted given the permissions store
 * snapshot. Returns true if access is allowed, false if it should be blocked.
 *
 * Caller MUST ensure modules are already loaded before calling this.
 */
function isPathAllowed(to, allowedLinks) {
    const path = to.path.toLowerCase();

    // Exact match against an allowed link
    if (allowedLinks.has(path)) return true;

    // Prefix match for sub-pages (e.g. /wh/material-incomings/123)
    for (const link of allowedLinks) {
        if (path.startsWith(link + "/")) return true;
    }

    // Match against the route definition path to handle dynamic segments
    // (/:id, /:tab?, etc.)
    for (const match of to.matched) {
        const defPath = match.path.toLowerCase();
        if (allowedLinks.has(defPath)) return true;
        // Strip dynamic segments: /path/:id/:tab? → /path
        const stripped = defPath.replace(/\/:[^/]*/g, "").replace(/\/\*/g, "");
        if (stripped && allowedLinks.has(stripped)) return true;
    }

    return false;
}

router.beforeEach(async (to, from) => {
    // Cancel in-flight GET requests from the page we are leaving.
    // Only on real page changes (not query/param tweaks within the same page,
    // and not on the initial navigation where `from` has no name).
    if (from.name && to.path !== from.path) {
        swapGetControllerForNavigation();
    }
    checkAppNewVersion();
    const isAuthenticated = localStorage.getItem("token");

    // 1. Public routes — always allowed
    if (to.meta?.public) {
        document.title = (to.name || "") + " | CASTCORE";
        return true;
    }

    // 2. Auth gate
    if (to.name !== "Login" && !isAuthenticated) {
        return { name: "Login" };
    }
    if (isAuthenticated && to.name === "Login") {
        return { name: "Home" };
    }

    // 3. Routes that bypass module-permission checks
    //    Either listed by name globally, or opted out per-route via
    //    `meta: { skipModuleCheck: true }`. These still require login, but
    //    don't need a specific module permission to access.
    if (
        UNRESTRICTED_ROUTE_NAMES.has(to.name) ||
        to.matched.some((r) => r.meta?.skipModuleCheck)
    ) {
        document.title = (to.name || "") + " | CASTCORE";
        return true;
    }

    // 4. From here on, the route requires module-level permission. Module
    //    permissions are project-scoped, so we need a selected project first.

    let project = null;
    try {
        project = JSON.parse(localStorage.getItem("project") || "null");
    } catch (e) {
        project = null;
    }
    if (!project || !project.type) {
        // No project selected → bounce to general dashboard (unrestricted).
        return { path: "/general-dashboard" };
    }

    // 5. Ensure modules for the current project type are loaded. The store
    //    de-dupes concurrent calls, so this is safe to await on every nav.
    try {
        await store.dispatch("permissions/ensureLoaded", project.type);
    } catch (e) {
        // Loading errors are surfaced via store.status === 'error'
    }

    const perm = store.state.permissions;

    if (perm.modules.length === 0) {
        return { path: "/general-dashboard" };
    }

    // If we still don't have a loaded snapshot (e.g. network failure), don't
    // accidentally grant access — send the user to a safe landing page.
    if (perm.status !== "loaded") {
        return { path: "/general-dashboard" };
    }

    // 6. Permission decision
    const isSuperAdmin = store.getters["permissions/isSuperAdmin"];
    const allowedLinks = store.getters["permissions/allowedLinks"];

    if (isSuperAdmin || isPathAllowed(to, allowedLinks)) {
        document.title = (to.name || "") + " | CASTCORE";
        return true;
    }

    // 7. Not allowed → redirect to the first accessible page (or general
    //    dashboard as a fallback).
    const fallback = getFirstAllowedPath(perm.modules);
    const target = fallback && fallback !== "/" ? fallback : "/";

    // Avoid redirect loop in pathological cases.
    if (target === to.path) {
        return { path: "/" };
    }
    return { path: target };
});

router.afterEach(() => {
    abortNavigationGetController();
});

export { getFirstAllowedPath, isPathAllowed };
export default router;
